<template>
  <page class="comments">
    <section class="new-comment content__narrow">
      <section-title>
        {{ $tc('p.contentPage.title.comments', contentComments.length, {count: contentComments.length}) }}
      </section-title>
      <comment-form />
    </section>
    <section class="comments content__narrow">
      <comment
        v-for="comment in contentComments"
        :key="comment.id"
        :comment="comment"
      />
    </section>
  </page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PageMixin from '@/mixins/pages/Page'
import Comment from '@/components/comments/Comment'
import CommentForm from '@/components/comments/CommentForm'

export default {
  mixins: [PageMixin],
  components: {
    Comment,
    CommentForm
  },
  computed: {
    ...mapState({
      content: state => state.content.content,
      contentComments: state => state.contentComments.comments
    }),
  },
  methods: {
    ...mapActions([
      'fetchContentComments',
    ]),
  },
  created () {
    this.fetchContentComments(this.content.id)
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.page.comments
  background-color: transparent
  margin-top: -95px

.new-comment__form
  margin-top: -18px

.new-comment__form .button-input
  margin-top: 20px

section.comments
  margin-top: 40px

.comment
  border-radius: $border-radius
  background-color: #f0f3f5
  font-size: 14px
  padding: 40px 40px 34px 100px
  position: relative
  margin-bottom: 10px

.comment__delete-button
  color: $color-grey-2
  cursor: pointer
  position: absolute
  right: 24px
  top: 22px

  &:hover
    color: darken($color-grey-2, 10%)

.comment__header
  margin-bottom: 15px

.comment__author-avatar
  height: 42px
  left: 41px
  position: absolute
  top: 41px
  width: 42px

.comment__author-name
  font-weight: 500
  font-size: 15px

.comment__created-at
  color: $color-grey-2
  font-size: 12px
  margin-top: -5px

.comment__body
  font-size: 15px
  line-height: 1.8

  p + p
    margin-top: 0
</style>



// WEBPACK FOOTER //
// src/components/contents/content/ContentComments.vue